import React from 'react';
import clsx from 'clsx';
import './Switch.scss';

type Color = 'primary' | 'secondary';

type Size = 'small' | 'medium';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  color?: Color;
  className?: string;
}

const BASE_CLASS = 'ui-kit-switch';

const Switch: React.FC<Omit<Props, 'size'> & { size?: Size }> = ({
  color = 'primary',
  size = 'small',
  className,
  ...rest
}) => {
  const classNameSwitch = clsx(`${BASE_CLASS}`, `${BASE_CLASS}-size-${size}`, className);
  const classNameSlider = clsx(`${BASE_CLASS}-slider`, `${BASE_CLASS}-${color}`);

  return (
    <span className={classNameSwitch}>
      <input type="checkbox" {...rest} />
      <span className={classNameSlider} />
    </span>
  );
};

export default Switch;
